export enum Language {
    EST = "EST",
    ENG = "ENG",
    RUS = "RUS"
}
